import React from 'react';
import { Image, Text, Link } from '@fluentui/react-components';

import { getWebMDLogoImg, getWebMdPage } from 'src/utils/utils';
import { WEDMD_URL } from 'src/utils/constants';
import AccreditedBadge from 'src/components/molecules/accredited-badge/AccreditedBadge';
import useTeamsFx from 'src/hooks/useTeamsFx';
import { useFooterStyles } from './Footer.styles';

const TERMS_URL = getWebMdPage('/Policies/Terms');
const POLICIES_URL = getWebMdPage('/Policies');
const CONTACT_URL = getWebMdPage('/ContactUs');
const ACCREDITED_01_IMG = '/images/Accredited-NCQA-PHP.png';
const ACCREDITED_02_IMG = '/images/Accredited-NCQA-WHP.png';
const ACCREDITED_03_IMG = '/images/Accredited-urac.png';
const ACCREDITED_04_IMG = '/images/Accredited-soc4so.png';

const Footer: React.FC = () => {
  const { themeString } = useTeamsFx();
  const webmdLogoImg = getWebMDLogoImg(themeString);
  const styles = useFooterStyles();

  return (
    <div className={styles.footerContainer} data-testid="footer">
      <div className={styles.firstContentContainer}>
        <div className={styles.logoContainer}>
          <Image className={styles.webMdLogoImg} src={webmdLogoImg} alt="WebMd Logo" />

          <div className={styles.contactContainer}>
            <Link className={styles.commonTextStyles} target="_blank" href={POLICIES_URL}>Policies</Link>

            <Link className={styles.commonTextStyles} target="_blank" href={CONTACT_URL}>Contact Us</Link>

            <Link className={styles.commonTextStyles} target="_blank" as="a">Language: English</Link>
          </div>
        </div>

        <div className={styles.copyrightContainer}>
          <Text className={styles.commonTextStyles}>© 2025</Text>

          <Link className={styles.commonTextStyles} target="_blank" href={WEDMD_URL}>WebMD Health Services Group, Inc.</Link>

          <Text className={styles.commonTextStyles}>All rights reserved.</Text>
        </div>

        <Text className={styles.commonTextStyles}>WebMD does not provide medical advice, diagnosis or treatment.</Text>

        <Link className={styles.commonTextStyles} target="_blank" href={TERMS_URL}>See additional information.</Link>
      </div>

      <div className={styles.secondContentContainer}>
        <div className={styles.accreditedImgContainer}>
          <AccreditedBadge src={ACCREDITED_01_IMG} alt="Accredited-NCQA-PHP">
            <span className={styles.redColor}>3 YEARS</span>
          </AccreditedBadge>

          <AccreditedBadge src={ACCREDITED_02_IMG} alt="Accredited-NCQA-WHP">
            <span className={styles.redColor}>3 YEARS</span>
          </AccreditedBadge>

          <AccreditedBadge src={ACCREDITED_03_IMG} alt="Accredited-urac">
            <span>Accredited</span>

            <span>Health Website</span>

            <span className={styles.fontSizeXS}>Expires 7/1/2025</span>
          </AccreditedBadge>

          <AccreditedBadge src={ACCREDITED_04_IMG} alt="Accredited-soc4so" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
